export const toNano = (value: number) => {
    return value * 10**9
}